module.exports = __webpack_public_path__ + "static/media/bg.488a3ff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/movie/bg.mp4
// module id = 8ai+
// module chunks = 1